import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteStudentEnrollment as apiFn } from "../../api/apiStudentEnrollments";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useDeleteStudentEnrollment() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deleteEnrollment, isPending: isDelete } = useMutation({ mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["studentEnrollments"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { deleteEnrollment, isDelete }; }
